import { isStartFen } from '@domain/chess/types';
import { gameOutcome, snapshotPieces } from '@state/actions';
import { gameStore } from '@state/gameStore';
import { evalBarWhiteShare } from '@visuals/valuation/mapEval';
import './EvalBar.css';

/** Slim vertical eval. White-positive; white sits on the board’s bottom side. */
export function EvalBar() {
  const whiteShare = () => {
    void gameStore.fen;
    void gameStore.cursor;
    const matedSide =
      gameOutcome() === 'checkmate' ? snapshotPieces().turn : null;
    return evalBarWhiteShare(gameStore.engine.score, {
      isStart: isStartFen(gameStore.fen),
      matedSide,
    });
  };
  const whiteBottom = () => gameStore.orientation === 'white';

  return (
    <div
      class="eval-bar"
      classList={{ 'eval-bar--white-top': !whiteBottom() }}
      title="Evaluation (white vs black)"
    >
      <div class="eval-bar__white" style={{ height: `${whiteShare() * 100}%` }} />
    </div>
  );
}
